import React from 'react'
import axios from 'axios'
import _ from 'lodash'
import { Table, Icon, Dropdown, Input, Dimmer, Loader, Image, Modal, Button } from 'semantic-ui-react'
import { BlueMoon, Dimple, handleError } from '../BlueMoon';
import './dbData.css'
import { setTimer } from '../UserBehaviour/UserBehaviourTimer'
import ErrorMessage from '../Common/ErrorMessage';
import { Helmet } from 'react-helmet'
import { numberWithCommas } from '../Common/NumberWithComas';
import RowComponent from './RowComponent'
import Status from './Status'
import { getTheme } from '../../config/clientConfig'

class DBDataV2 extends React.Component {
    constructor(props) {
        super(props);
        this.theme = getTheme();
        this.state = {
            currentPage: 1,
            sortColumns: [],
            edit: false,
            deletedRows: [],
            brandToAssetMapping: [],
            editData: {},
            sort: { meScore: true, eventDate: false, durationTime: false },
            sortPriority: ["meScore", "durationTime", "eventDate"],
            brands: [], assets: [], params: {},
            dimmerActive: false, tableData: [], maxOffset: 0, offset: 0, colors: this.theme.tableRows
            , filter: {}, error: false
        };
    }



    shouldComponentUpdate(nextProps, nextState) {

        if(this.state.currentPage !== nextState.currentPage){
            return true;
        }

        if(this.state.dimmerActive != nextState.dimmerActive){
            return true;
        }

        if (!_.isEqual(this.state.sortColumns, nextState.sortColumns)){
            return true;
        }

        if (!_.isEqual(this.state.tableData, nextState.tableData))
            return true;

        else if (this.state.deletedRows.length > 0 && nextState.deletedRows.length == 0)
            return true;

        if (nextState.editData.length > 0) return true;

        if (this.state.edit != nextState.edit) return true

        return !_.isEqual(this.state.sort, nextState.sort)
    }

    componentWillReceiveProps = (nextProps, currentProps) => {
       console.log("paramchange",this.state.params, nextProps.params);
        setTimer('rawdata');
        if (!_.isEqual(this.state.params, nextProps.params))
        {
            // console.log("refreshing mismatch");
            this.fetchData();
        }
            
    }

    hitUpdateRequest = (data, index) => {
        axios({
            method: 'post',
            url: `${BlueMoon.ip}editData/change/${localStorage.getItem('user')}`,
            data: data
        }).then((response) => {
            if (response.data) {
                var editData = this.state.editData;
                editData[index].status = true;
                this.setState({ editData: editData })
            }
        });
    }

    updateToDB = () => {

        this.state.editData.map((row, index) => {
            if (!row.status) {
                this.hitUpdateRequest({ [row.operation]: row.data }, index);
            }
        });

    }


    addChanges = () => {
        var dataLength = this.state.backupData.length;
        var changedRows = _.range(0, dataLength).filter((row, index) => {
            return (!_.isEqual(this.state.backupData[index], this.state.tableData[index]) && !this.state.deletedRows.includes(this.state.tableData[index]._id) && index < dataLength)
        }).map((index) => {
            return [this.state.tableData[index], this.state.backupData[index]]
        });

        var deletedRows = this.state.deletedRows.map((id) => {
            return { data: this.state.backupData.filter((x) => x._id === id), status: false, operation: "delete" }
        });

        var editRows = changedRows.map((x) => {
            var oldChange = x[1]
            var newChange = x[0]

            return { data: [oldChange, newChange], status: false, operation: "edit" };
        })


        this.setState({ editData: _.concat(editRows, deletedRows) }, () => {
            this.updateToDB();
        })
    }

    fetchDataCount = () => {
        let countParams = {... this.props.params};
        delete countParams["sortColumns"];
        delete countParams["sort"];
        delete countParams["offset"];
        delete countParams["sortPriority"];
        axios.get(`${BlueMoon.ip}dashboard/dataCount/`, {
            params: countParams
        }).then((response) => {

            this.setState({ maxOffset: _.floor(response.data.dataCount[0].totalDataCount / 50), totalDataCount: response.data.dataCount[0].totalDataCount, offset: 0 }, () => {
                this.fetchRawData();
            });
        }).catch((err) => {
            handleError(err);
        });
    }

    deleteRow = (id) => {
        var deletedRows = this.state.deletedRows;
        deletedRows.push(id);
        this.setState({ deletedRows: deletedRows })
    }

    fetchRawData = () => {
        let filterParams = _.cloneDeep(this.props.params);
        console.log(this.state.sortColumns, "sortcols");
        axios.get(`${BlueMoon.ip}DbDatav2`, {
            params: Object.assign(this.props.params, {
                offset: this.state.offset, sort: _.keys(this.state.sort).reduce((prev, curr) => {
                    if (prev != "")
                        return prev + ` ${curr}=${this.state.sort[curr]}`

                    return prev + `${curr}=${this.state.sort[curr]}`
                }, ''), sortColumns: this.state.sortColumns.map(x => x.col+"!"+x.order ).join(",")
            })
        }).then((response) => {
            if (!_.isEmpty(response.data)) {
                this.setState({ params: filterParams, tableData: response.data, backupData: _.cloneDeep(response.data), finalBackup: _.cloneDeep(response.data), dimmerActive: false, error: false, sort: this.state.sort, currentPage: this.state.offset+1 });
            }
            else
                this.setState({ error: true, dimmerActive: false })
        });
    }

    fetchData = () => {
        this.setState({tableData: [], dbDate: [], backupData: [], dimmerActive: true }, () => {
            this.fetchDataCount();
        })
    }


    getUniqueBrandsToAssets = () => {
        axios.get(`${BlueMoon.ip}distinct/brand/asset/`, {
        }).then((response) => {
            this.setState({
                brandToAssetMapping: response.data,
                brands: _.keys(response.data).map((x) => { return { text: x, value: x, key: x } }),
            });

        });
    }


    fetchBrandsAssets = () => {
        this.getUniqueBrandsToAssets();
    }

    componentDidMount = () => {
        this.fetchBrandsAssets();
        this.fetchData();
    }


    onSortV2 = (column, event) =>{
        console.log("event ", event.ctrlKey, event.metaKey);
        let additive = event.ctrlKey || event.metaKey;
        let foundCol = _.find(this.state.sortColumns, {col: column});
        let nextSortState = [];
        if (foundCol === undefined){

            let newState = [];
            if(additive){
                newState = [...this.state.sortColumns, {"col": column, "order":  "asc"}];
            }else{
                newState = [{"col": column, "order":  "asc"}];
            }
            console.log("setting new state");
            nextSortState = {sortColumns: newState};
        }else{
            if(foundCol.order === "asc"){
                let index = _.findIndex(this.state.sortColumns, foundCol);

                let newState = [...this.state.sortColumns];
                let newCol = {"col": column, order: "desc"};
                newState[index] = newCol;
                console.log("setting new state", newCol);
                if(additive){
                    console.log("desc", newState);
                    nextSortState = {sortColumns: newState};
                    this.setState();
                }else{
                    nextSortState = {sortColumns: [newCol]};
                }
                
            }else{
                let newState = _.filter(this.state.sortColumns, (x) => x.col !== column);
                console.log("setting new state");
                if(additive){
                    nextSortState = {sortColumns: newState};
                }else{
                    nextSortState = {sortColumns: []};
                }
                
            }
        }
        this.setState(nextSortState);
        
    }

    onSort = (column) => {
        var sortPriorityTemp = this.state.sortPriority;

        if (this.state.sortPriority.includes(column))
            sortPriorityTemp.splice(sortPriorityTemp.indexOf(column), 1);
        sortPriorityTemp.unshift(column);

        var tempSort = this.state.sort;
        if (column in tempSort)
            tempSort[column] = !tempSort[column]
        else
            tempSort[column] = false

        this.setState({ sort: tempSort, sortPriority: sortPriorityTemp, tableData: [], offset: 0}, () => {
            this.fetchRawData()
        })
    }

    refresh = () => {
        console.log("refreshed")
        window.location.reload();
    }

    componentDidUpdate = (prevProps, prevState) => {
        console.log(this.state.currentPage !== prevState.currentPage, this.state.currentPage, prevState.currentPage, "comp updated")
        // if(this.state.currentPage !== prevState.currentPage){
        //     console.log("comp updated for page change")
        //     return true;
        // }

        if(!_.isEqual(prevState.sortColumns,this.state.sortColumns)){
            console.log("sortstate", prevState.sortColumns, this.state.sortColumns)
            this.setState({dimmerActive: true}, () =>{
                this.fetchRawData();
            });
            
        }

        if (!_.isEmpty(document.getElementsByTagName('tr'))) {
            var dropDowns2 = document.getElementsByClassName("ui selection dropdown")

            var thElements = document.getElementsByTagName('tr')[0].getElementsByTagName('th');
            for (var i = 0; i < thElements.length - 1; i++) {
                if (i >= 0) {
                    thElements[i].setAttribute('style', `cursor: pointer; font-size: 1.1em;color: ${this.theme.text.highlight} !important;font-family: sans-serif;paddingLeft:0em;paddingRight:0em;`);
                    thElements[i].style.zIndex = 0;
                    thElements[i].style.zIndex = 0;
                }
            }

            if (dropDowns2.length > 0) {
                for (var i = 0; i < dropDowns2.length / 2; i++) {
                    dropDowns2[2 * i].style.backgroundColor = this.theme.forms.inputBackground;
                    dropDowns2[2 * i].style.color = this.theme.text.highlight;
                    dropDowns2[2 * i + 1].style.backgroundColor = this.theme.forms.inputBackground;
                    dropDowns2[2 * i + 1].style.color = this.theme.text.highlight;
                }
            }
        }

    }

    renamedHeaders = (header) => {
        switch (header) {
            case "sourceMediaType": return "type"; break;
            case "eventDate": return "Event date"; break;
            case "channelName": return "channel"; break;
            case "chtype": return "channelType"; break;
            case "durationTime": return "duration"; break;

            case "durationExposure": return "Duration Exposure"; break;
            case "t30SecEq": return "30 Second Equivalents"; break;
            case "durationperExposure": return "Duration Per Exposure"; break;
            case "exposureSum": return "Exposure Sum"; break;
            case "exposureCount": return "Exposure Count"; break;

            case "channelSubtype": return "Channel Subtype"; break;
            case "mediaType": return "Media Type"; break;
            case "actualViews": return "Actual Views"; break;            
            case "meScore": return "ME Score"; break;
            case "adjustedImpressions": return "Adjusted Impressions"; break;
            case "meValue": return "ME Value ($)"; break;
            case "gameDesignation": return "Game Designation"; break;

            default: return header;
        }
    }

    aliasToDBName = (header) => {
        switch (header) {
            case "type": return "sourceMediaType"; break;
            case "channel": return "channelName"; break;
            case "channelType": return "channelType"; break;
            case "eventDate": return "Event Date"; break;
            case "Brand": return "brand"
            default: return header;
        }
    }


    reset = () => {
        this.setState({ sortColumns:[], tableData: [], backupData:[], deletedRows: [], sort: { meScore: true, eventDate: false, durationTime: false },
            sortPriority: ["meScore", "durationTime", "eventDate"]}, () => {
            this.fetchRawData();
        });
    }

    addRowBack = (id) => {
        var deletedRows = this.state.deletedRows;
        var index = deletedRows.indexOf(id);
        deletedRows.splice(index, 1);
        this.setState({ deletedRows: deletedRows });
    }

    onPageChange = (event) =>{
        let newVal = parseInt(event.currentTarget.value);
        if(newVal === this.state.currentPage){
            return;
        }
        if(newVal > this.state.maxOffset + 1){
            newVal = this.state.maxOffset + 1;
        }
        if(newVal <= 0){
            newVal = 1;
        }
        console.log(newVal, "currentpage")
        this.setState({currentPage: newVal});
    }

    render() {
        if (_.isEmpty(localStorage.getItem('token'))) window.location.replace(`${Dimple}#/login`);
        
        if (_.isEmpty(localStorage.getItem('projectIp'))) window.location.replace(`${Dimple}#/home`);

        if(localStorage.getItem('userRole') !== "admin")  return <ErrorMessage isNormal = {true}/>

        if (this.state.error) return <ErrorMessage />

        if (this.state.dimmerActive || _.isEmpty(this.state.brands))
            return <Dimmer active={true}>
                <Loader />
            </Dimmer>
        if (this.state.editData.length > 0) return <Status editables={this.state.editData} refresh={this.refresh} />
        return (<div style={{boxSizing: 'border-box', display: 'flex', flexDirection: "column", minHeight: '0'}}>


            <div className={'tableFixHead'} style={{ boxSizing: "border-box" }}>
                <table style={{ backgroundColor: this.theme.backgrounds.panel, color: this.theme.text.primary }} >
                    <thead>
                        <tr>
                            {/* <th> <Icon name={(this.state.edit) ? 'cancel' : 'pencil'} style={{ cursor: 'pointer' }} onClick={() => { this.setState({ edit: !this.state.edit }) }} /> </th> */}
                            {
                                _.keys(this.state.tableData[0]).map((header, index) => {

                                    // if (_.isEqual(header, "meScore") || _.isEqual(header, "durationTime") || _.isEqual(header, "eventDate")) {
                                    //     var isDesc = (this.state.sort[(header == "duration") ? "durationTime" : header])
                                    //     isDesc = (_.isUndefined(isDesc)) ? false : isDesc
                                    //     return <th>{(header == "meScore") ? "ROI($)" : _.capitalize(header)}<Icon onClick={this.onSort.bind(this, (header == "duration") ? "durationTime" : header)} style={{ cursor: 'pointer' }} disabled={this.state.edit} name={(!isDesc) ? 'caret down' : 'caret up'} /></th>
                                    // }
                                    header = this.renamedHeaders(header);

                                    if (!(_.isEqual(header, "project") | _.isEqual(header, "mediaUrl") | _.isEqual(header, "id"))){
                                        let sortDesc = _.find(this.state.sortColumns, {col: header});
                                        console.log("sortDesc", sortDesc);
                                        let showSort = sortDesc !== undefined;
                                        let isDesc = _.get(sortDesc, "order", "asc") === "desc";
                                        console.log(isDesc, "isDesc")
                                        return <th onClick={this.onSortV2.bind(this, header)} style={{ cursor: 'pointer', fontFamily: 'sans-serif', fontSize: '1.1em', padding: '0em' }} textAlign={'center'} verticalAlign={'middle'} >{_.capitalize(this.renamedHeaders(header))}
                                        {<Icon className={showSort? "enabled": ""} onClick={this.onSort.bind(this, header)} disabled={false} name={(isDesc) ? 'caret down' : 'caret up'} /> }
                                        </th>
                                    }
                                        
                                })

                            }
                            <th><Icon name={'image'} size={'large'} /> </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.tableData.map((row, index) => {
                                var backgroundColor = this.state.colors[(index + 1) % 2];
                                var isDeleted = this.state.deletedRows.includes(row._id)

                                return <RowComponent edit={this.state.edit} brandToAssetMapping={this.state.brandToAssetMapping} isDeleted={isDeleted} brandNames={this.state.brands} deleteRow={this.deleteRow} addRow={this.addRowBack} editRow={this.editRow} row={row} index={index} backgroundColor={backgroundColor} />
                            })
                        }

                    </tbody>
                </table>
            </div>

            <div style={{ flex: 'wrap', float: 'right', padding: '1rem', boxSizing: "border-box", display: 'flex', justifyContent: 'flex-end', alignItems: "center" }}>


                <span style={{ color: this.theme.text.primary, paddingRight: '1rem', boxSizing: 'border-box' }}> {`Total Records: ${numberWithCommas(_.toString(this.state.totalDataCount))}`}</span>
                <Icon color={'grey'} name={'caret left'} style={{ cursor: 'pointer' }} disabled={(this.state.offset > 0) ? false : true} size={'big'} onClick={() => {
                    this.setState({ offset: this.state.offset - 1, tableData: [], backupData: [], dimmerActive: true }, () => {
                        this.fetchRawData();
                    })
                }} />
                <span style={{ color: this.theme.text.primary, paddingRight: '1rem', boxSizing: 'border-box' }}> Page {<input onInput={this.onPageChange} style={{width: `${Math.ceil(Math.log10(this.state.maxOffset+2))+1}rem`, textAlign: "center", padding: "0.25rem"}} type='number' max={this.state.maxOffset+1} min={1} value={this.state.currentPage} />} {` of ${numberWithCommas(_.toString(this.state.maxOffset + 1))}`}</span>
                <Icon name={'caret right'} color={'grey'} style={{ cursor: 'pointer' }} disabled={(this.state.offset == this.state.maxOffset) ? true : false} size={'big'} onClick={() => {
                    this.setState({ offset: this.state.offset + 1, tableData: [], backupData: [], dimmerActive: true }, () => {
                        this.fetchRawData();
                    })
                }} />
                <span style={{"color": "white"}} className='ui blue button' onClick={() =>{
                    if(this.state.currentPage-1 === this.state.offset){
                        return;
                    }
                    this.setState(this.setState({offset: this.state.currentPage-1, dimmerActive: true}, () =>{
                        this.fetchRawData();
                    }))
                    
                }}>Go</span> 
            </div>
            <Helmet>

                <style type="text/css">{`
       .ui.labeled.icon.button, .ui.labeled.icon.buttons .button{
           padding-left: 1.5em !important;
           padding-right: 0.5em !important;
       }
    `}</style>
            </Helmet>
        </div>

        )

    }
}

export default DBDataV2;